
import { defineComponent } from 'vue'
import TheNavigation from '@/components/Shared/TheNavigation.vue'
import UserMenu from '@/components/Shared/UserMenu.vue'

export default defineComponent({
  components: {
    TheNavigation,
    UserMenu
  },
  props: {
    subtitle: { type: String, default: '' }
  },
  emits: ['logout']
})
